import React from 'react';
import { Box, Tooltip } from '@mui/material';
import FilterChip from './FilterChip';
import {
  FEEDBACK_SESSION_STATUS_FILTERS,
  getStatusText,
  getStatusColor,
  getStatusTextColor,
  getStatusBorderColor,
  getStatusDescription
} from '../../../constants/feedbackSessionStatuses';

const tooltipConfig = {
  arrow: true,
  placement: 'top',
  enterDelay: 500,
  leaveDelay: 200
};

const FeedbackSessionStatus = ({
  selectedStatuses = [],
  onStatusToggle,
  statuses = null, // If null, shows all statuses. If array, shows only specified statuses
  sx = {}
}) => {
  // Determine which statuses to show.
  // ADR-014 §10: the default vocabulary is FEEDBACK_SESSION_STATUS_FILTERS —
  // the four lifecycle states with the terminal one split into "Completed"
  // (everything finished) and "Closed" (closed early). Chip labels
  // therefore match the chips rendered on the cards exactly.
  const statusesToShow = statuses || Object.values(FEEDBACK_SESSION_STATUS_FILTERS);

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      {statusesToShow.map((status) => {
        const statusText = getStatusText(status);
        const isSelected = selectedStatuses.includes(status);

        return (
          // ADR-014 §10i: the filter row is where the labels are least
          // guessable ("Configuration"), so every chip explains itself.
          <Tooltip key={status} title={getStatusDescription(status)} {...tooltipConfig}>
            <FilterChip
              label={statusText}
              isSelected={isSelected}
              onClick={() => onStatusToggle(status)}
              backgroundColor={getStatusColor(status)}
              textColor={getStatusTextColor(status)}
              borderColor={getStatusBorderColor(status)}
              showDot={true}
            />
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default FeedbackSessionStatus;
